import { actions } from '@/modules/Rapport/store/actions';
import { getters } from '@/modules/Rapport/store/getters';
import { mutations } from '@/modules/Rapport/store/mutations';
import { state } from '@/modules/Rapport/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { RapportState } from './state';

const module: Module<RapportState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { RapportState };
